import BaseEntityService from '../core/base-entity-service';

export interface WatchlistItem {
  id: string;
  symbol: string;
  originalSymbol: string;
  type: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

interface WatchlistApiResponse {
  data?: WatchlistItem[];
  results?: WatchlistItem[];
}

export default class WatchlistService extends BaseEntityService {
  static override route = 'charts/watchlist-items';

  async getItems(): Promise<WatchlistItem[]> {
    try {
      const result = await this.httpService.get<WatchlistApiResponse>(
        this.path,
      );
      return result?.data ?? result?.results ?? [];
    } catch {
      return [];
    }
  }

  async addItem(symbol: string, type = 'Stock'): Promise<WatchlistItem | null> {
    try {
      return await this.httpService.post<
        { symbol: string; type: string },
        WatchlistItem
      >(this.path, { symbol, type });
    } catch {
      return null;
    }
  }

  async removeItem(id: string): Promise<boolean> {
    try {
      await this.httpService.delete<void>(`${this.path}/${id}`);
      return true;
    } catch {
      return false;
    }
  }

  async removeItemBySymbol(symbol: string): Promise<boolean> {
    try {
      await this.httpService.delete<void>(
        `${this.path}/by-symbol/${encodeURIComponent(symbol)}`,
      );
      return true;
    } catch {
      return false;
    }
  }
}
